/**
 * @author: lv.chen3
 * @desc: Project列表面板组件
 * @date: 2025/3/23
 */
import React from 'react';
import classnames from 'classnames';
import { useDebounceFn } from 'ahooks';
import { List } from 'tea-component';
import OptionText from '../OptionText';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IListPanelProps extends IBaseProps {
  title?: string;
  searchValue?: string;
  currentValue?: string;
  options?: IGPSelectOptionWithGroup[] | null;
  onSelect?: (payload?: string) => void;
}

const ListPanel: React.FC<IListPanelProps> = (props) => {
  const { style, className, title, searchValue, currentValue, options, onSelect } = props;

  const { run: handleClickRun } = useDebounceFn(
    (payload?: string) => {
      onSelect?.(payload);
    },
    { wait: 300 },
  );

  return (
    <div style={style} className={classnames('dbg-pipeline-project-switcher-list-panel', className)}>
      <div className="dbg-pipeline-project-switcher-list-panel__title">{title || ''}</div>
      <div>
        <List type="option">
          {options?.map((option) => {
            const { value, text, icon } = option || {};
            return (
              <List.Item
                key={value}
                selected={!!currentValue && value === currentValue}
                onClick={(e) => {
                  e?.stopPropagation();
                  handleClickRun(value);
                }}
              >
                <OptionText searchValue={searchValue} text={text as string} cover={icon} />
              </List.Item>
            );
          })}
        </List>
      </div>
    </div>
  );
};

export default ListPanel;
